import React from 'react';
import { Link } from 'react-router-dom';
import QRCode from 'qrcode.react';

export class QRCodeToggle extends React.Component {
    state = { visible: false };
    render() {
        const { url } = this.props;
        const { visible } = this.state;
        return visible
            ? (
                <div className="docItmex-qr">
                    <QRCode value={url} renderAs="canvas" size={90} includeMargin={true} />
                    <button type="button" className="docItmex-qr-ocultar" onClick={() => this.setState({ visible: false })}>Ocultar</button>
                </div>
            )
            : (
                <button type="button" className="docItmex-boton" onClick={() => this.setState({ visible: true })} aria-label="Mostrar código QR">
                    <i className="fas fa-qrcode"></i>
                </button>
            );
    }
}

// Una fila por documento: nombre, versión y fecha, y acciones (abrir PDF y QR)
export const DocRow = ({ href, label, version, date }) => (
    <li className="docItmex-fila">
        <span className="docItmex-icono"><i className="fas fa-file-pdf"></i></span>
        <span className="docItmex-info">
            <a href={href} target="_blank" rel="noopener noreferrer">{label}</a>
            <span>{version} · {date}</span>
        </span>
        <span className="docItmex-acciones">
            <QRCodeToggle url={href} />
            <a className="docItmex-boton docItmex-boton--oscuro" href={href} target="_blank" rel="noopener noreferrer" aria-label={`Abrir ${label}`}>
                <i className="fas fa-arrow-right"></i>
            </a>
        </span>
    </li>
);

export const DocSection = ({ icon, title, subtitle, children }) => (
    <div className="docItmex-seccion">
        <h2 className="promosItmex-grupo-titulo"><i className={`fas ${icon}`}></i>
            <span>{title}{subtitle && <small>{subtitle}</small>}</span>
        </h2>
        <ul className="docItmex-lista">{children}</ul>
    </div>
);

export const DocMigas = ({ actual }) => (
    <nav className="docItmex-migas" aria-label="breadcrumb">
        <Link to="/documentacion">Documentación</Link>
        <i className="fas fa-chevron-right"></i>
        <span aria-current="page">{actual}</span>
    </nav>
);
